<template>
    <div>
        <div class="search-layout" v-if="enableSearch != null && enableSearch == true">
            <swb-query-sort-area ref="query_model_ctrl" :config="queryConfig" :queryKey="queryKey" :queryOnLoad="false" :queryHandler="queryHandler" :onConfigReady="onQueryConfigReady"></swb-query-sort-area>
        </div>
        <div class="org-tree">
            <el-radio-group v-if="isRadio" v-model="checkComId" style="display: block;height: calc(100% - 52px - 28px)">
                <el-tree class="filter-tree" :accordion="accordion" :node-key="'nodeKey'" :data="comList" :highlight-current="highlightCurrent" :props="defaultProps" @node-click="clickNode" :filter-node-method="filterNode" ref="comTree" :render-content="renderContent" @node-expand="nodeExpand" @node-collapse="nodeCollapse" :default-expanded-keys="openNodeKeys"></el-tree>
            </el-radio-group>
            <div style="height: calc(100% - 52px - 28px)" v-else>
                <a class="swb-btn swb-btn-mini" @click="allSelect" v-if="multiSelect">全选</a>
                <a class="swb-btn swb-btn-mini" @click="resetSelect" v-if="multiSelect">全不选</a>
                <el-tree class="filter-tree" :accordion="accordion" :show-checkbox="multiSelect" :default-checked-keys="defaultCheckedKeys" :node-key="'nodeKey'" :data="comList" :highlight-current="highlightCurrent" :props="defaultProps" @node-click="clickNode" :filter-node-method="filterNode" ref="comTree" :render-content="renderContent" @node-expand="nodeExpand" @node-collapse="nodeCollapse" :default-expanded-keys="openNodeKeys" @check-change="handleCheckChange"></el-tree>
            </div>
        </div>
    </div>
</template>

<script>
import { Utils } from '../../app.base'

import retailerApi from '../../api/retailer'
import { MsgBox } from '../../app.vues';
import { openRealComInfoDlg } from './selectDlg';

let mockConfigData = {
    'queryFields': [
        {
            'code': 'searchTitle',
            'label': '公司',
            'type': 'Text',
            'valueType': 'String',
            'basic': true,
            'hidden': false,
            'rptUsed': false,
            'useLikeMatch': true,
            'ctxBindName': null
        },
        {
            'code': 'costCenterTitle',
            'label': '成本中心',
            'type': 'Text',
            'valueType': 'String',
            'basic': true,
            'hidden': true,
            'rptUsed': false,
            'useLikeMatch': true,
            'ctxBindName': null
        },
        {
            'code': 'prftCenterTitle',
            'label': '利润中心',
            'type': 'Text',
            'valueType': 'String',
            'basic': true,
            'hidden': true,
            'rptUsed': false,
            'useLikeMatch': true,
            'ctxBindName': null
        },
        {
            'code': 'fiscalPeriodOpen',
            'label': '会计期间状态',
            'type': 'Select',
            'valueType': 'Boolean',
            'value': null,
            'basic': true,
            'hidden': false,
            'rptUsed': false,
            'ctxBindName': null,
            'dataList': [
                {
                    value: null,
                    label: '- 全部 -'
                },
                {
                    value: true,
                    label: '开启'
                },
                {
                    value: false,
                    label: '未开启'
                }
            ]
        }
    ],
    'sortFields': [
        {
            'code': 'name',
            'label': '名称',
            'order': 'asc',
            'enabled': true
        }
    ]
};

export default {
    name: 'swb-real-com-tree',
    desc: '组织架构树组件',
    props: {
        enableSearch: {
            type: Boolean,
            default: true
        },
        accordion: {    // 是否手风琴模式
            type: Boolean,
            default: false
        },
        dblclickFlag: { // 是否双击事件
            type: Boolean,
            default: false
        },
        costFlag: { // 获取成本中心
            type: Boolean,
            default: false
        },
        prftFlag: { // 获取利润中心
            type: Boolean,
            default: true
        },
        selectRealComId: {  // 当前实体公司Id
            type: Number,
            default: null
        },
        multiSelect: { // 多选
            type: Boolean,
            default: false
        },
        isRadio: { // 展示单选框
            type: Boolean,
            default: false
        },
        realComDefFirst: { // 公司树是否默认第一个
            type: Boolean,
            default: true
        },
        deprFlag: { // 实体公司查询累计折旧
            type: Boolean,
            default: false
        }
    },
    watch: {},
    data: function () {
        return {
            highlightCurrent: true,
            filterText: '',
            comList: [],
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            treeCollapse: true,
            openNodeKeys: [],
            lastSelectedNodeId: null, // 最后一次触发节点Id
            lastSelectTime: null, // 最后一次触发时间
            defaultCheckedKeys: [],
            checkComId: null,
            checkComItem: null,
            //
            firstLoad: true,
            checkedNodes: [], // 多选时保存的已选择节点
            queryConfig: null,
            queryKey: null,
            queryModel: {
                filterItems: {},
                sortItemList: [],
                sortItems: {}
            }
        }
    },
    created: function () {
        this.queryConfig = Utils.merge({}, mockConfigData);
        this.getRealComList();
        this.checkComId = this.selectRealComId;
    },
    methods: {
        onQueryConfigReady: function (event) {
            let self = this;
            setTimeout(function () {
                let query_model_ctrl = self.$refs['query_model_ctrl'];
                let fieldInfo = {};
                if (self.costFlag) {
                    fieldInfo['costCenterTitle'] = {
                        hidden: false
                    };
                }
                if (self.prftFlag) {
                    fieldInfo['prftCenterTitle'] = {
                        hidden: false
                    };
                }
                query_model_ctrl.updateFields(fieldInfo);
            }, 500);
        },
        queryHandler: function (queryModel) {
            this.queryModel = queryModel;
            this.getRealComList();
        },
        handleCheckedChange: function () {
            this.getRealComList();
        },
        nodeExpand(data, node, vueComponent) {
            this.openNodeKeys.push(data.nodeKey);
        },
        nodeCollapse(data, node, vueComponent) {
            this.openNodeKeys.remove(data.nodeKey);
        },
        getRealComList: function () {
            let self = this;
            let queryModel = this.queryModel;
            let filterItems = Utils.merge({}, queryModel.filterItems);
            //
            filterItems.costFlag = this.costFlag || null;
            filterItems.prftFlag = this.prftFlag || null;
            filterItems.deprFlag = this.deprFlag || false;
            let sortedFilter = {
                filterItems: filterItems,
                sortItemList: Utils.merge([], queryModel.sortItemList),
                sortItems: Utils.merge({}, queryModel.sortItems)
            }
            let theLoad = MsgBox.loading();
            retailerApi.getRealComTreeList(sortedFilter, function (result, jqXhr) {
                theLoad.hide();
                if(result.type == 'info') {
                    let data = result.data || [];
                    //
                    //对树节点数据进行过滤处理（设置 nodeKey）
                    self.normalizeTreeNode(data);
                    //
                    self.comList = Utils.merge([], data);
                    //
                    if(data != null && data.length > 0) {
                        if(self.firstLoad) {
                            // 首次加载根据参数勾选
                            let currentRealCom = null;
                            if(Utils.isNoB(self.selectRealComId)) {
                                if(self.realComDefFirst) {
                                    currentRealCom = data[0];
                                }
                            } else {
                                currentRealCom = data.find(function (item) {
                                    return item.id == self.selectRealComId;
                                });
                                if(Utils.isNoB(currentRealCom) && self.realComDefFirst) {
                                    currentRealCom = data[0];
                                }
                            }
                            if(!Utils.isNoB(currentRealCom)) {
                                self.defaultCheckedKeys = ['com-' + currentRealCom.id];
                                self.notityInitChange(currentRealCom);
                            }
                        } else {
                            let checkedNodes = self.checkedNodes;
                            self.defaultCheckedKeys = checkedNodes.pluck('nodeKey');
                        }
                    }
                } else {
                    self.$message.error(result.message);
                }
                self.firstLoad = false;
            })
        },
        // 回复初始选择
        resetSelect: function () {
            if(this.realComDefFirst) {
                let realComList = this.comList || [];
                let realCom = realComList[0];
                let dataList = [{
                    id: 'com-' + realCom.id,
                    label: realCom.code + ' ' + realCom.name
                }];
                this.$refs.comTree.setCheckedNodes(dataList);
                this.defaultCheckedKeys = ['com-' + realCom.id];
                this.notityInitChange(realCom);
            } else {
                this.$refs.comTree.setCheckedNodes([]);
                this.defaultCheckedKeys = [];
                this.checkedNodes = [];
                this.notityInitChange(null);
            }
        },
        filterNode: function (value, data) {
            if(!value) {
                return true;
            }
            return data.name.indexOf(value) !== -1;
        },
        getCheckedNodes: function () {
//                let selectDatas = this.$refs.comTree.getCheckedNodes();
//                console.log("selectDatas" + selectDatas);
//                return selectDatas;
            console.log('checkedNodes', this.checkedNodes);
            return this.checkedNodes;
        },
        renderContent: function (createElement, node) {
            let leafFlag = node.data.leafFlag;
            if(leafFlag) {
                let children = node.data.children || [];
                if(children == null || children.length <= 0) {
                    leafFlag = true;
                } else {
                    leafFlag = false;
                }
            }
            node.node.isLeaf = leafFlag;
            let selfTree = this;
            return createElement({
                data: function () {
                    return {
                        isRadio: selfTree.isRadio,
                        checkComId: selfTree.checkComId,
                        item: node
                    };
                },
                template: '<span style=" display: inline-block; width: calc(100% - 25px);" v-if="!isRadio">' +
                    '<span class="inline-block ellipsis pr10" style="width: 100%;margin-top:3px;">' +
                    '<i v-if="item.data.realFlag" class="icon iconfont icon-gongsi1 mr5 font-blue"></i>' +
                    '<i v-else-if="item.data.costFlag" class="icon iconfont icon-mendian1 mr5 font-blue"></i>' +
                    '<i v-else class="icon iconfont icon-mendian mr5 font-blue"></i>' +
                    '<span v-if="item.data.realFlag">{{item.data.code}}&nbsp;{{item.data.name}}</span>' +
                    '<span v-else>{{item.data.name}}</span>' +
                    '<span v-if="item.data.realFlag" class="el-icon-document fr mr5" @click="showDetail($event, item.data.id)"></span>' +
                    '</span>' +
                    '</span>' +
                    '<span v-else>' +
                    '<el-radio class="radio" v-model="checkComId" :label="item.data.id">' +
                    '<i v-if="item.data.realFlag" class="icon iconfont icon-gongsi1 mr5 font-blue"></i>' +
                    '<i v-else-if="item.data.costFlag" class="icon iconfont icon-mendian1 mr5 font-blue"></i>' +
                    '<i v-else class="icon iconfont icon-mendian mr5 font-blue"></i>' +
                    '<span v-if="item.data.realFlag">{{item.data.code}}&nbsp;{{item.data.name}}</span>' +
                    '<span v-else>{{item.data.name}}</span>' +
                    '<span v-if="item.data.realFlag" class="el-icon-document fr mr5" @click="showDetail($event, item.data.id)"></span>' +
                    '</el-radio>' +
                    '</span>',
                methods: {
                    handleTooltip(item) {
                        let toolTip = item.name + '-' + item.code;
                        return toolTip;
                    },
                    showDetail(event, id) {
                        event.stopPropagation();
                        //
                        openRealComInfoDlg(id);
                    }
                }
            });
        },
        normalizeTreeNode: function (data) {
            Utils.forEachTreeNode(data, function (nodeData) {
                let nodeId = nodeData['id'] || null;
                if(nodeId == null) {
                    nodeId = Utils.genUniqueStr();
                }
                //
                let level = nodeData['level'] || null;
                if(Utils.isNoB(level)) {
                    nodeData['nodeKey'] = 'center-' + nodeId;
                    nodeData['realFlag'] = false;
                    nodeData['centerFlag'] = true;
                    nodeData['leafFlag'] = true;
                } else {
                    nodeData['nodeKey'] = 'com-' + nodeId;
                    nodeData['realFlag'] = true;
                    nodeData['centerFlag'] = false;
                }
            }, function (treeNode) {
                let costCenters = treeNode.costCenters || [];
                costCenters.forEach(function (item) {
                    item.costFlag = true;
                });
                let prftCenters = treeNode.prftCenters || [];
                prftCenters.forEach(function (item) {
                    item.costFlag = false;
                });
                let children = costCenters.concat(prftCenters);
                //
                treeNode.children = children;
                return children;
            });
        },
        clickNode: function (data) {
            if(this.multiSelect) {
                return;
            }
            if(this.isRadio) {
                this.checkComId = data.id;
                this.checkComItem = data;
            } else {
                if(this.dblclickFlag) {
                    let nodeId = data.id + '' + data.realFlag;
                    //
                    let lastSelectedNodeId = this.lastSelectedNodeId;
                    let lastSelectTime = this.lastSelectTime;
                    if(!Utils.isNoB(lastSelectedNodeId) && !Utils.isNoB(lastSelectTime)) {
                        let time = new Date().getTime();
                        let t = time - lastSelectTime;
                        if(lastSelectedNodeId === nodeId && t < 500) {
                            this.notityChange(data);
                        }
                    }
                    //
                    this.lastSelectedNodeId = nodeId;
                    this.lastSelectTime = new Date().getTime();
                } else {
                    this.notityChange(data);
                }
            }
        },
        notityChange: function (data) {
            //
            let resultData = {};
            resultData.id = data.id;
            resultData.realFlag = data.realFlag;
            resultData.centerFlag = data.centerFlag;
            if(data.centerFlag) {
                resultData.realComId = data.realComId;
            }
            resultData.name = data.name;
            resultData.code = data.code;
            resultData.aggtDeprWorth = data.aggtDeprWorth;
            //
            this.checkComItem = resultData;
            this.$emit('notity-change', resultData);
        },
        notityInitChange: function (data) {
            //
            let resultData = {};
            if(!Utils.isNoB(data) && data.id > 0) {
                resultData.id = data.id;
                resultData.realFlag = data.realFlag;
                resultData.centerFlag = data.centerFlag;
                if(data.centerFlag) {
                    resultData.realComId = data.realComId;
                }
                resultData.name = data.name;
                resultData.code = data.code;
                resultData.aggtDeprWorth = data.aggtDeprWorth;
            }
            this.checkComItem = resultData;
            this.$emit('notity-init-change', resultData);
        },
        //组织树收缩
        showTreeCollapse: function () {
            this.treeCollapse = this.treeCollapse ? false : true;
            this.$emit('show-tree-collapse', this.treeCollapse)
        },
        allSelect: function () {
            let realComList = this.comList || [];
            //
            let checkedKeys = [];
            for(let i = 0; i < realComList.length; i++) {
                let realCom = realComList[i];
                checkedKeys.push('com-' + realCom.id);
            }
            this.defaultCheckedKeys = checkedKeys;
        },
        handleCheckChange(data, checked, indeterminate) {
            let checkedNodes = this.checkedNodes;
            if(checked) {
                checkedNodes.push(data);
            } else {
                // remove nodeKey
                for(let i = 0; i < checkedNodes.length; i++) {
                    if(checkedNodes[i]['nodeKey'] == data['nodeKey']) {
                        checkedNodes.splice(i, 1);
                        break;
                    }
                }
            }
            this.checkedNodes = Utils.merge([], checkedNodes);
            console.log('checkedNodes', this.checkedNodes);
        },
        getDlgResult() {
            let self = this;
            let result = {};
            if(this.checkComId != null) {
                result.type = 'info';
                result.data = self.checkComItem;
            } else {
                result.type = 'warn';
                result.message = '请选择实体公司';
            }
            return result;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/orgStruct/RealComTree.vue